import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'lin-cell-multiline-text',
  template: ` <div class="text-truncate"><ng-content></ng-content></div> `,
  styles: [
    `
      .text-truncate {
        flex-wrap: wrap;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MultilineTextCellComponent {}
